import { defineComponent } from 'vue';
import { Progress } from '@/components/UI';
import useTranslations from '@/compositions/useTranslations';
export default defineComponent({
    name: 'MistakesLeft',
    components: {
        Progress
    },
    setup: () => ({
        ...useTranslations()
    }),
    computed: {
        percentage() {
            return this.$store.direct.state.rooms.score;
        },
        variant() {
            const mistakesLeft = this.$store.direct.state.rooms.mistakesLeft;
            console.log('mistakesLeft', mistakesLeft);
            if (mistakesLeft > 2) {
                return 'green';
            }
            else if (mistakesLeft > 1) {
                return 'orange';
            }
            else {
                return '#b51f24';
            }
        }
    }
});
